<template>
  <div>
    <span v-if="typeof governingDocumentID === 'string' || typeof governingDocumentID === 'number'">
      <button
        class="button is-info is-light is-small is-outline is-rounded"
        @click.prevent="downloadPdf(governingDocumentID, documentURL)"
      >
        Pdf
      </button>
    </span>
    <span v-else>
      &nbsp;
    </span>
  </div>
</template>

<script>
export default {
  props: {
    governingDocumentID: [Number, String],
    documentID: [Number, String],
    documentURL: String,
    downloadPdf: Function
  }
}
</script>
